<template>
    <web-entry-selector-layout title="Contacts Editor" :show-nav="availableModes.length > 1" :modes="availableModes" :error="validationError" :agencies="agencies" @ori-change="handleOriChange" @mode-change="handleModeChange" @submit="handleSubmit">
        <template v-slot:extra-fields-edit>
            <div class="mt-1">
                <label class="form-label mb-1 fw-bolder">Incident Number:</label>
                <input type="text" class="form-control form-text " v-model="idInput" :required="true" aria-required="true"/>
            </div>
        </template>
    </web-entry-selector-layout>    
</template>
<script setup lang="ts">

import { computed, ref, watch, onMounted } from 'vue';
import { SelectEntryType, SelectItem, SelectorMode } from '@/types';
import WebEntrySelectorLayout from '@/components/BSelector/WebEntrySelectorLayout.vue';
import { useContactsStore } from '@/stores/contactsStore';
import { AxiosResponse } from 'axios';
import { addIdPropertyToTargetArrays, handleErrorInResponse } from '@/utils';
import { storeToRefs } from 'pinia';

const props = withDefaults(defineProps<{
    showNotFoundError: boolean,
        initialOri: string,
        initialIncidentNumber: string,
        url: string
}>(),{
    initialOri:'',
    initialIncidentNumber:''
});

var idInput = ref(props.initialIncidentNumber);

const currentMode = ref({} as SelectEntryType);
const availableModes = ref([] as SelectorMode[]);
const validationError = ref("");

availableModes.value.push({type:SelectEntryType.Edit, label:'Edit', isDefaultSelection: true});

const contactsStore = useContactsStore();
contactsStore.setSelectedOri(props.initialOri);

var agencies = ref([] as SelectItem[])

const isValid = (mode:SelectEntryType):Boolean => {
    return contactsStore.getSelectedOri.value != "" && idInput.value != "";    
}

const notFoundMessage=computed(() => {
    let ori = contactsStore.getOriName;
    return `Unable to find the incident: ${idInput.value} in ${ori ?? contactsStore.getSelectedOri.value}. Please try your search again or contact your administrator.`;
});

defineExpose({ isValid })

function handleOriChange(newOri) {
    contactsStore.setSelectedOri(newOri);        
}

function handleModeChange(mode:SelectEntryType){    
    currentMode.value = mode;
    idInput.value = '';
}

function handleSubmit(ori:any, mode:SelectEntryType) {   
    
    if (contactsStore.getSelectedOri.value !== "" && idInput.value !== "") {
        validationError.value = "";
        try{
            contactsStore.fetchContacts(idInput.value, contactsStore.getSelectedOri.value).then((response:AxiosResponse) => {

            if (response == undefined || response.data == null || response.data.incident_number == null) {
                validationError.value = notFoundMessage.value;
            }
            else {
                contactsStore.contactFullReport = response.data;
                addIdPropertyToTargetArrays(contactsStore.contactFullReport);
            
                window.location.href = `ContactsEditor.aspx?incident=${encodeURIComponent(idInput.value)}&ori=${encodeURIComponent(contactsStore.getSelectedOri.value)}`;
                }
            });

        } catch (error) {
            contactsStore.contactFullReport = undefined;
            handleErrorInResponse(error);        
        }                
    }    
}

onMounted(() => {
    

    if (props.showNotFoundError) {
        validationError.value = notFoundMessage.value;
        }
})

watch(
    () => contactsStore.getSelectedOri,
    (val) => {
        validationError.value = "";
    }
);

watch(
    () => contactsStore.oris,
    () => {
        agencies.value = contactsStore.getOrisForSelectList;
    }
);

watch(
    () => idInput.value,
    (val) => {
        validationError.value = "";
    }
);

</script>

<style src="@vueform/multiselect/themes/default.css"></style>